import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { computed, defineComponent, onBeforeMount, ref, toRefs } from "@vue/composition-api";
import { useVuelidate } from "@Shared/@Composables/validations/useVuelidate";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { sameAsWithLabel, validPassword } from "@Shared/@Utils/validation-rules";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import TimezoneSelect from "@Shared/components/inputs/timezone-select.vue";
import RulesPasswordInput from "@Shared/components/inputs/rules-password-input.vue";
import { TOS_EXTERNAL_LINK } from "@Shared/@Utils/constants";
import { decodeDetailsToken } from "@Client/@Utils/custom";
import { useRoute } from "@Shared/@Composables/route/useRoute";
import { useI18n } from "vue-i18n-composable";
import * as AccountActions from "@Client/@Modules/main/store/account/account-actions";
import { useAccountStoreActions } from "@Client/@Modules/main/store/account/account-helpers";
import TextField from "@Shared/components/form-elements/fields/text-field.vue";
import ApplicationStandaloneLoader from "@Client/@Modules/application-standalone/components/loaders/application-standalone-loader.vue";
import PasswordInput from "@Shared/components/inputs/password-input.vue";
export default defineComponent({
  name: "PersonalDetailsStep",
  components: {
    SimpleButton,
    TimezoneSelect,
    RulesPasswordInput,
    TextField,
    ApplicationStandaloneLoader,
    PasswordInput
  },
  mixins: [validationMixin],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    loadingStatus: {
      type: Boolean,
      default: true
    },
    isBrokerInvitation: {
      type: Boolean,
      default: false
    },
    loadingDetails: {
      type: Boolean,
      default: false
    }
  },
  validations: {
    formData: {
      accountType: {
        required
      },
      email: {
        required,
        email
      },
      familyName: {
        required
      },
      givenName: {
        required
      },
      password: {
        required,
        validPassword
      },
      passwordRepeat: {
        required,
        confirmPassword: sameAsWithLabel("Password above")("password")
      },
      timezone: {
        required
      }
    },
    terms: {
      required(value) {
        return value;
      }
    }
  },
  setup(props, {
    emit
  }) {
    const {
      v$
    } = useVuelidate();
    const {
      isBrokerInvitation,
      loadingDetails: loadingDetailsProp
    } = toRefs(props);
    const emailChecked = ref(true);
    const loadingCheckEmail = ref(false);
    const loadingStatusCheckEmail = ref(true);
    const terms = ref(false);
    const {
      locale
    } = useI18n();
    const formData = ref({
      applicationId: null,
      accountType: "Client",
      currentSubdomain: window.location.pathname.replace("/", ""),
      email: "",
      familyName: "",
      givenName: "",
      password: "",
      passwordRepeat: "",
      phoneNumber: "",
      timezone: "",
      locale: locale.value,
      isGhost: false,
      referrerId: ""
    });
    const isFrenchLanguage = computed(() => {
      return locale.value === "fr-CA";
    });
    const isValid = computed(() => {
      var _v$$value$$invalid, _v$$value;
      return (_v$$value$$invalid = !(v$ != null && (_v$$value = v$.value) != null && _v$$value.$invalid)) != null ? _v$$value$$invalid : false;
    });
    const isEmailValid = computed(() => {
      var _v$$value$formData$em, _v$$value2;
      return (_v$$value$formData$em = !(v$ != null && (_v$$value2 = v$.value) != null && _v$$value2.formData.email.$invalid)) != null ? _v$$value$formData$em : false;
    });
    const showForm = computed(() => isBrokerInvitation.value || emailChecked.value);
    const tosExternalLink = computed(() => {
      return TOS_EXTERNAL_LINK();
    });
    const showMatchPasswordsError = computed(() => {
      return v$.value.formData.passwordRepeat.$invalid && v$.value.formData.passwordRepeat.$dirty;
    });
    const loadingDetails = computed({
      get() {
        return loadingDetailsProp.value;
      },
      set(value) {
        emit("update:loadingDetails", value);
      }
    });
    const {
      CHECK_IF_EMAIL_ACCOUNT_EXISTS
    } = useAccountStoreActions([AccountActions.CHECK_IF_EMAIL_ACCOUNT_EXISTS]);
    onBeforeMount(() => {
      loadInvitation();
    });
    const handleCheckEmail = async () => {
      if (!isEmailValid.value) return;
      loadingCheckEmail.value = true;
      const emailAlreadyExists = await CHECK_IF_EMAIL_ACCOUNT_EXISTS({
        email: formData.value.email
      });
      if (emailAlreadyExists === undefined) {
        loadingStatusCheckEmail.value = false;
        loadingCheckEmail.value = false;
        return;
      }
      loadingStatusCheckEmail.value = true;
      loadingCheckEmail.value = false;
      if (emailAlreadyExists) {
        emit("show-login", formData.value.email);
        return;
      }
      emailChecked.value = true;
    };
    const handleSubmit = async () => {
      if (!isValid.value) return;
      emit("sign-up", {
        formData: _objectSpread(_objectSpread({}, formData.value), {}, {
          locale: locale.value
        })
      });
    };
    const handleMatchInputBlur = () => {
      v$.value.formData.passwordRepeat.$touch();
      if (!formData.value.passwordRepeat) v$.value.formData.passwordRepeat.$reset();
    };
    const loadInvitation = async () => {
      loadingDetails.value = true;
      const {
        params: paramsToken,
        t: detailsToken,
        r: referrerId = ""
      } = useRoute().query;
      if (!paramsToken && !detailsToken) {
        emailChecked.value = false;
        loadingDetails.value = false;
        return;
      }
      const {
        isGhost,
        emailFromShare,
        applicationId = null,
        givenName,
        familyName,
        phoneNumber,
        locale: accountLocale
      } = await decodeDetailsToken({
        token: detailsToken,
        params: paramsToken
      });
      if (accountLocale && accountLocale !== locale.value) locale.value = accountLocale;
      if (isGhost && emailFromShare) {
        emit("update:isBrokerInvitation", true);
        emailChecked.value = true;
        formData.value = _objectSpread(_objectSpread({}, formData.value), {}, {
          isGhost,
          email: emailFromShare,
          applicationId,
          givenName,
          familyName,
          phoneNumber,
          locale: accountLocale,
          referrerId: referrerId
        });
      }
      loadingDetails.value = false;
    };
    return {
      v$,
      formData,
      isValid,
      isEmailValid,
      showForm,
      terms,
      tosExternalLink,
      showMatchPasswordsError,
      loadingCheckEmail,
      loadingStatusCheckEmail,
      handleCheckEmail,
      handleMatchInputBlur,
      handleSubmit,
      isFrenchLanguage
    };
  }
});